var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-fast-forward",
    "data-name": "Icon awesome-fast-forward",
    d: "M36,5.344V30.656a.846.846,0,0,1-.844.844H32.344a.846.846,0,0,1-.844-.844V19.976l-12.059,11a2.251,2.251,0,0,1-3.691-1.73V6.75a2.253,2.253,0,0,1,3.691-1.73L31.5,15.947V5.344a.846.846,0,0,1,.844-.844h2.813A.846.846,0,0,1,36,5.344Z",
    transform: "translate(-7 0.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerNext);
export default __webpack_public_path__ + "static/media/playerNext.b06c433fc6eced7b6b1972d95d46eb5c.svg";
export { ForwardRef as ReactComponent };